import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import * as IncidentService from '_services/incident-service';

const initialState = {
    incidents: [],
    selectedIncident: null,
    createStatus: 'idle',
    view: 'list', // 'list' | 'create' | 'detail'
};

export const createIncident = createAsyncThunk(
    "incidents/createIncident",
    async (data) => {
        return await IncidentService.createIncident(data);
    }
);

const incidentsSlice = createSlice({
    name: 'incidents',
    initialState,
    reducers: {
        reset: () => initialState,
        setIncidents: (state, action) => {
            state.incidents = action.payload;
        },
        setSelectedIncident: (state, action) => {
            state.selectedIncident = action.payload;
        },
        setView: (state, action) => {
            state.view = action.payload;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(createIncident.pending, (state) => {
                state.createStatus = 'loading';
            })
            .addCase(createIncident.fulfilled, (state) => {
                state.createStatus = 'succeeded';
            })
            .addCase(createIncident.rejected, (state) => {
                state.createStatus = 'failed';
            });
    },
});

export const { reset, setIncidents, setSelectedIncident, setView } = incidentsSlice.actions;

export const selectIncidents = (state) => state.incidents.incidents;
export const selectSelectedIncident = (state) => state.incidents.selectedIncident;
export const selectView = (state) => state.incidents.view;
export const selectCreateStatus = (state) => state.incidents.createStatus;

export default incidentsSlice.reducer;
